import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Header, FieldName, FieldValue } from '../_local/styles'
import Pencil from '@material-ui/icons/Edit'
import EducationDialog from '../_local/modals/EducationDialog'
import { getEducationFields } from '../service'
import { Box, Button } from '@material-ui/core'
import { getHtmlForEachTag } from '../WorkExperienceRow'

const EducationRow = (props) => {
  const { education, id, setPropChange, certificates, languages } = props
  const [open, setOpen] = useState(false)

  const initialValues: any = {
    certificates: certificates || [],
    languages: languages || [],
    expertId: id,
    educations:
      education.length >= 1
        ? education
        : [
            {
              id: undefined,
              degree: '',
              endDate: null,
              major: '',
              schoolName: '',
              startDate: null,
            },
          ],
  }
  certificates.name = 'Certificates'
  languages.name = 'Languages'

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Header>Education</Header>
        </Grid>
        <Grid item>
          <Button onClick={handleClickOpen} startIcon={<Pencil />} color="primary">
            Edit
          </Button>
        </Grid>
      </Grid>

      <Box style={{ width: '75%' }}>
        {initialValues.educations.map((item, index) => {
          const sortedFields = {
            degree: item.degree,
            endDate: item.endDate,
            major: item.major,
            schoolName: item.schoolName,
            startDate: item.startDate,
          }

          return (
            <Grid container key={index} spacing={5}>
              {Object.entries(sortedFields).map((field, index) => {
                const formattedFields = getEducationFields(field)

                return (
                  <Grid item key={index}>
                    <FieldName>{formattedFields?.label}</FieldName>
                    <FieldValue>{formattedFields?.value}</FieldValue>
                  </Grid>
                )
              })}
            </Grid>
          )
        })}
      </Box>
      <Box style={{ width: '75%' }}>
        <Grid container spacing={5}>
          {[languages, certificates].map((array, index) => {
            return (
              <Grid item key={index}>
                <FieldName>{array.name}</FieldName>
                <>{getHtmlForEachTag(array)}</>
              </Grid>
            )
          })}
        </Grid>
      </Box>
      <EducationDialog
        open={open}
        handleClose={handleClose}
        initialValues={initialValues}
        setPropChange={setPropChange}
      />
    </>
  )
}

export default EducationRow
